import { useQuery } from '@tanstack/react-query';

import { useLibraryPostsGateway } from './LibraryPostsGatewayProvider';
import { getPublicCommunityPostV2QueryOptions } from '../api/queryOptions';

/** A post opened from a public share link. */
export function useSharedLibraryPost(token: string) {
  return useQuery(getPublicCommunityPostV2QueryOptions({ token }, useLibraryPostsGateway()));
}
